import type { NextRouter } from 'next/router';
import { logToDatadog } from '@/domains/shared/analytics/datadogUtils';
import { resolveDeepLink } from './resolveDeepLink';

/** Minimal router surface we need — satisfied by both `useRouter()` and the
 *  `next/router` singleton, so callers can use whichever fits. */
type DeepLinkRouter = Pick<NextRouter, 'push'>;

/**
 * Resolve `input` and navigate to the mapped feature. Returns `true` if the
 * link was recognised and navigation was triggered, `false` otherwise.
 *
 * This is the single choke point every deep-link entry point funnels through
 * (Universal/App Links today; Iterable push + in-app messages next), so all
 * routing behaviour lives in one place.
 */
export function navigateToDeepLink(
  router: DeepLinkRouter,
  input: string,
): boolean {
  const target = resolveDeepLink(input);

  if (!target) {
    logToDatadog('warn', `Unrecognised deep link ignored: ${input}`);
    return false;
  }

  logToDatadog('info', `Deep link resolved: ${input} -> ${target.path}`);
  void router.push(target.path);
  return true;
}
